import React from "react";

const images = [
  "/images/husqvarna/img01.jpg",
  "/images/husqvarna/img02.jpg",
  "/images/husqvarna/img03.jpg",
  "/images/husqvarna/img04.jpg",
  "/images/husqvarna/img05.jpg",
  "/images/husqvarna/img06.jpg",
];

const timeline = [
  { year: "1689", event: "Fundação como fábrica de armas" },
  { year: "1872", event: "Produtos domésticos" },
  { year: "1903", event: "Motocicletas" },
  { year: "1959", event: "Motosserras" },
  { year: "1995", event: "Robô cortador solar" },
  { year: "2024", event: "Tecnologia a bateria e CEORA" },
];

const curiosidades = [
  "A Husqvarna é uma das empresas industriais mais antigas do mundo ainda em operação.",
  "O primeiro robô cortador de grama solar do mundo foi lançado pela Husqvarna em 1995.",
  "A marca é referência global em soluções sustentáveis para áreas verdes e florestais.",
];

const HusqvarnaPage = () => (
  <div className="min-h-screen bg-gray-100 font-inter animate-fade-in">
    <div className="max-w-5xl mx-auto p-6">
      <h1 className="text-3xl md:text-4xl font-bold text-husqvarna-dark-gray mb-4">História da Husqvarna</h1>
      <p className="text-lg text-husqvarna-dark-gray/90 mb-8">
        Fundada em 1689 na Suécia, a Husqvarna evoluiu em três séculos para se tornar referência global em tecnologia de jardinagem e linha Florestal.
      </p>

      {/* Galeria de imagens */}
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 mb-10">
        {images.map((src, idx) => (
          <div
            key={idx}
            className="overflow-hidden rounded-lg shadow bg-white flex items-center justify-center aspect-[4/3] transition-transform duration-300"
            style={{ minHeight: 0 }}
            tabIndex={0}
          >
            <img
              src={src}
              alt={`Husqvarna ${idx + 1}`}
              className="object-cover w-full h-full husqvarna-img-zoom"
              style={{ maxHeight: "220px", width: "100%", transition: "transform 0.3s" }}
              loading="lazy"
              onError={e => { e.target.src = "https://via.placeholder.com/400x300?text=Imagem+Indisponível"; }}
            />
          </div>
        ))}
      </div>

      {/* Linha do tempo */}
      <h2 className="text-2xl font-bold text-husqvarna-orange mb-4">Linha do Tempo</h2>
      <ul className="mb-8 pl-4 border-l-4 border-husqvarna-orange">
        {timeline.map((item, idx) => (
          <li key={idx} className="mb-2 pl-2 text-husqvarna-dark-gray">
            <span className="font-semibold text-husqvarna-orange">{item.year}</span> – {item.event}
          </li>
        ))}
      </ul>

      {/* Curiosidades */}
      <h2 className="text-2xl font-bold text-husqvarna-orange mb-4">Curiosidades</h2>
      <ul className="mb-8 list-disc pl-8 text-husqvarna-dark-gray/90">
        {curiosidades.map((cur, idx) => (
          <li key={idx} className="mb-2">{cur}</li>
        ))}
      </ul>

      {/* Link oficial */}
      <a
        href="https://www.husqvarna.com.br"
        target="_blank"
        rel="noopener noreferrer"
        className="inline-block bg-husqvarna-orange text-white px-6 py-3 rounded-full font-semibold shadow hover:bg-orange-700 transition-colors duration-300"
      >
        Acesse o site oficial da Husqvarna Brasil
      </a>
    </div>
    <style>
      {`
        .animate-fade-in {
          animation: fadeIn 1s ease;
        }
        @keyframes fadeIn {
          from { opacity: 0; transform: translateY(20px);}
          to { opacity: 1; transform: translateY(0);}
        }
        .husqvarna-img-zoom:hover,
        .husqvarna-img-zoom:focus {
          transform: scale(1.08);
          z-index: 2;
        }
      `}
    </style>
  </div>
);

export default HusqvarnaPage;
